import { DatePipe } from "@angular/common";
import { Pipe } from "@angular/core";


@Pipe({
    pure: true,
    name: "date",
    standalone: false
})
export class DateOnlyPipe extends DatePipe {
     public transform(value: string | number | Date, format: string = 'dd/MM/yyyy',timezone: string = "GMT-3"): any {
      return super.transform(value, format, timezone);
    }
  }
  